interface CardItem {
  title: string;
  description: string;
  tag: string;
  imageAlt: string;
  imageUrl: string;
}

const cards: CardItem[] = [
  {
    title: '热门真人秀精选',
    description: '集结当下最火爆的真人秀节目，《奔跑吧》《极限挑战》《向往的生活》等热门综艺一网打尽，每日更新最新剧集。',
    tag: '真人秀',
    imageAlt: '天天影视热门真人秀综艺节目精选推荐',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dynamic%20reality%20TV%20show%20production%20scene%20with%20colorful%20stage%20lighting%2C%20warm%20coral%20and%20golden%20tones%2C%20entertainment%20atmosphere%2C%20professional%20lighting%20rig%2C%20clean%20composition&width=800&height=500&seq=card-show-01&orientation=landscape',
  },
  {
    title: '搞笑脱口秀合集',
    description: '《脱口秀大会》《吐槽大会》等搞笑综艺高清在线，幽默段子笑不停，放松心情的最佳选择。',
    tag: '脱口秀',
    imageAlt: '天天影视搞笑脱口秀综艺节目合集在线观看',
    imageUrl: 'https://readdy.ai/api/search-image?query=Comedy%20club%20stage%20with%20spotlight%20and%20microphone%20stand%2C%20warm%20atmosphere%2C%20modern%20interior%20design%2C%20golden%20accent%20lighting%2C%20cozy%20evening%20ambiance&width=800&height=500&seq=card-show-02&orientation=landscape',
  },
  {
    title: '音乐综艺经典舞台',
    description: '《中国好声音》《我是歌手》等音乐综艺的经典舞台表演，高清音质带你重温每一个感人瞬间。',
    tag: '音乐综艺',
    imageAlt: '天天影视音乐综艺节目经典舞台高清在线观看',
    imageUrl: 'https://readdy.ai/api/search-image?query=Music%20concert%20stage%20with%20dramatic%20spotlight%2C%20elegant%20performance%20atmosphere%2C%20warm%20golden%20stage%20lights%2C%20professional%20audio%20equipment%2C%20sophisticated%20theater%20setting&width=800&height=500&seq=card-show-03&orientation=landscape',
  },
  {
    title: '旅行美食节目',
    description: '跟着综艺去旅行，《中餐厅》《十二道锋味》等美食综艺带你走遍各地，品味人间烟火气。',
    tag: '美食旅行',
    imageAlt: '天天影视美食旅行综艺节目在线推荐',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20kitchen%20scene%20with%20fresh%20ingredients%20on%20wooden%20table%2C%20natural%20sunlight%20through%20window%2C%20rustic%20and%20cozy%20atmosphere%2C%20food%20photography%20style%2C%20soft%20shadows&width=800&height=500&seq=card-show-04&orientation=landscape',
  },
  {
    title: '恋爱观察综艺',
    description: '《心动的信号》《我们恋爱吧》等热门恋爱综艺，甜蜜互动、心动瞬间，高清画质沉浸式观感。',
    tag: '恋爱综艺',
    imageAlt: '天天影视恋爱观察综艺节目高清在线',
    imageUrl: 'https://readdy.ai/api/search-image?query=Romantic%20garden%20scene%20with%20soft%20fairy%20lights%20and%20blooming%20flowers%2C%20warm%20sunset%20glow%2C%20dreamy%20and%20tender%20atmosphere%2C%20cinematic%20composition%2C%20soft%20bokeh%20effect&width=800&height=500&seq=card-show-05&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block bg-accent-100 text-accent-800 text-xs font-semibold px-3 py-1 rounded-full uppercase tracking-wide mb-3">
            热门推荐
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-foreground-950 mb-3">
            综艺节目精选
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[600px] mx-auto">
            从真人秀到脱口秀，从音乐综艺到美食旅行——天天影视为你精选最值得看的综艺内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card) => (
            <article
              key={card.imageUrl}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-200 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={card.imageUrl}
                  alt={card.imageAlt}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="bg-primary-500 text-background-50 text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {card.description}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}